// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1iG_z","question":"Question_question__3AVOF","description":"Question_description__1bZWb"};